import gsap from "gsap";
import { Power3 } from "gsap/all";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger)

export default function ArticleInsight() {
    if (document.querySelector('.single-template')) {
        const menuLinks = document.querySelectorAll(".insight-link");
        const postContent = document.querySelector(".single-template");
        const headings = postContent.querySelectorAll("h2");
        const togglebutton = document.querySelector('.insightoggle')
        const togglemenu = document.querySelector('.insighttogglemenu')
        headings.forEach((heading, index) => {
            if (!heading.id) {
                heading.id = "section-" + (index + 1);
            }
        });


        menuLinks.forEach(link => {
            link.addEventListener("click", function (event) {
                event.preventDefault();
                const targetId = this.getAttribute("data-target");
                const targetSection = document.getElementById(targetId);

                if (targetSection) {
                    let offset = 50;

                    if(window.innerWidth < 575){
                        offset = 350
                    }
                    const targetPosition = targetSection.getBoundingClientRect().top + window.scrollY - offset;

                    window.scrollTo({
                        top: targetPosition,
                        behavior: "smooth"
                    });
                }
                if (window.innerWidth < 769) {
                    if (togglebutton.classList.contains('active')) {
                        togglebutton.classList.remove('active')
                        gsap.to(togglemenu, {
                            height: 0,
                            duration: .5,
                            ease: Power3.easeInOut
                        })
                    }
                }
            });
        });

        // window.onscroll = (() => {
        //     let mainSection = document.querySelectorAll('.single-template h2');

        //     mainSection.forEach((v, i) => {
        //         let rect = v.getBoundingClientRect().y
        //         if (rect < window.innerHeight - 200) {
        //             menuSection.forEach(v => v.classList.remove('active'))
        //             menuSection[i].classList.add('active')
        //         }
        //     })
        // })

        function updateActiveLink() {
            const sections = document.querySelectorAll(".single-template h2");
            const menu_links = document.querySelectorAll(".insight-link");

            const makeActive = (link) => menu_links[link].classList.add("active");
            const removeActive = (link) => menu_links[link].classList.remove("active");
            const removeAllActive = () => [...Array(sections.length).keys()].forEach((link) => removeActive(link));

            const sectionMargin = 100;

            let currentActive = 0;

            window.addEventListener("scroll", () => {

                const current = sections.length - [...sections].reverse().findIndex((section) => window.scrollY >= section.offsetTop - sectionMargin) - 1

                if (current !== currentActive) {
                    removeAllActive();
                    currentActive = current;
                    makeActive(current);
                }
            });
        }

        // window.addEventListener("scroll", updateActiveLink);
        updateActiveLink(); // Call on page load



        togglebutton.addEventListener('click', function () {
            if (window.innerWidth < 769) {
                if (!togglebutton.classList.contains('active')) {
                    gsap.to(togglemenu, {
                        height: 'auto',
                        duration: .4,
                        ease: Power3.easeInOut
                    })
                    togglebutton.classList.add('active')
                } else {
                    gsap.to(togglemenu, {
                        height: 0,
                        duration: .4,
                        ease: Power3.easeInOut
                    })
                    togglebutton.classList.remove('active')
                }
            }
        })



    }

}